export const classes = {
  message:
    'w-full px-5 py-2 text-lg text-grey-7 dark:text-mauve-2 text-center font-normal',
};
